import axios from 'axios';
import { toast } from 'react-toastify';
import {
  SCHEDULE_DELETE_SCHEDULE_BEGIN,
  SCHEDULE_DELETE_SCHEDULE_SUCCESS,
  SCHEDULE_DELETE_SCHEDULE_FAILURE,
  SCHEDULE_DELETE_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_DELETE_SCHEDULE_BEGIN,
    });
    const { projectId, version, taskId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}`;
      const doRequest = axios.delete(url, header);
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: SCHEDULE_DELETE_SCHEDULE_SUCCESS,
              data: res.data,
            });
            toast.success('Task Deleted Successfully !');
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: SCHEDULE_DELETE_SCHEDULE_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }

          dispatch({
            type: SCHEDULE_DELETE_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_DELETE_SCHEDULE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Deletion Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteScheduleError() {
  return {
    type: SCHEDULE_DELETE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_DELETE_SCHEDULE_BEGIN:
      return {
        ...state,
        deleteSchedulePending: true,
        deleteScheduleError: null,
      };

    case SCHEDULE_DELETE_SCHEDULE_SUCCESS:
      return {
        ...state,
        deleteSchedulePending: false,
        deleteScheduleError: null,
        tasks: action.data.schedules,
      };

    case SCHEDULE_DELETE_SCHEDULE_FAILURE:
      return {
        ...state,
        deleteSchedulePending: false,
        deleteScheduleError: action.data.error,
      };

    case SCHEDULE_DELETE_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        deleteScheduleError: null,
      };

    default:
      return state;
  }
}
